"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const AppNavHeader_1 = __importDefault(require("src/components/organisms/AppNavHeader"));
const Saver_1 = __importDefault(require("src/components/organisms/Saver"));
const AppFormGroup_1 = __importDefault(require("src/components/molecules/AppFormGroup"));
const reduxHooks_1 = require("src/hooks/reduxHooks");
const selectors_1 = require("src/stores/exportedStore/auth/selectors");
const thunk_1 = require("src/stores/applicationStore/profile/thunk");
const Edit = () => {
    const dispatch = (0, reduxHooks_1.useAppDispatch)();
    const [errors, setErrors] = (0, react_1.useState)(undefined);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const { handleSubmit, register } = (0, react_hook_form_1.useForm)();
    const me = (0, reduxHooks_1.useAppSelector)(selectors_1.selectUser);
    const onSubmit = (data) => {
        setErrors(undefined);
        setIsSuccess(false);
        let shouldRedirect = true;
        if (data.password === "") {
            shouldRedirect = false;
            data.password = undefined;
        }
        dispatch((0, thunk_1.editProfileThunk)({
            data,
            shouldRedirect,
            setErrors,
            setIsLoading,
            setIsSuccess,
        }));
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppNavHeader_1.default, { title: i18n_1.default.t("profile") }), (0, jsx_runtime_1.jsx)(Saver_1.default, Object.assign({ btnProps: { isLoading: isLoading, showSuccess: isSuccess }, onSubmit: handleSubmit(onSubmit) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { width: "320px" } }, { children: [(0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { defaultValue: me.first_name, error: errors === null || errors === void 0 ? void 0 : errors.first_name, label: i18n_1.default.t("First name"), register: register, registerName: "first_name" }), (0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { defaultValue: me.email, error: errors === null || errors === void 0 ? void 0 : errors.email, label: i18n_1.default.t("Email"), register: register, registerName: "email" }), (0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { defaultValue: me.phone_number, error: errors === null || errors === void 0 ? void 0 : errors.phone_number, label: i18n_1.default.t("Phone Number"), register: register, registerName: "phone_number" }), (0, jsx_runtime_1.jsx)(AppFormGroup_1.default, { autoComplete: "new-password", type: "password", error: errors === null || errors === void 0 ? void 0 : errors.password, label: i18n_1.default.t("Password"), placeholder: i18n_1.default.t("Enter new password"), register: register, registerName: "password" })] })) }))] }));
};
exports.default = Edit;
